// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/message-circle.js';

import { paths } from '../generated/message-circle';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('message-circle', Original, paths);
